import {
  getUserEditUsernameFormModalInitialValues,
  UserEditUsernameFormModal,
  useUserProfileContext,
  useUserProfileHeaderEditSubmit,
} from '../../../../User'

export function useUserProfilePageHeaderEditUsername() {
  const { handleCloseModal, setModal, userData } = useUserProfileContext()

  const { handleEditSubmit } = useUserProfileHeaderEditSubmit()

  function handleOpenEditUsernameModal() {
    setModal(
      <UserEditUsernameFormModal
        initialValues={getUserEditUsernameFormModalInitialValues(userData)}
        onClose={handleCloseModal}
        onSubmit={handleEditSubmit}
      />
    )
  }

  return {
    handleOpenEditUsernameModal,
  }
}
